import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

const ROUTE_PREFIX: string = 'admin.'

@vsingleton()
export class AdminCampaignRoute extends RouteBase {
  prefix = ROUTE_PREFIX

}

@vsingleton()
export class AdminCampaignApiRoute extends RouteBase {
  prefix = ROUTE_PREFIX + 'api.'

  baseCampaignSearch() {
    return this.ziggyRoute('base_campaign_search')
  }
}

